/**
 * EngineX const-enum interop.
 *
 * `LoopPhase` / `SubPhase` are `const enum`s. Under `isolatedModules` (Vite +
 * esbuild) you can't reference their members as values across module
 * boundaries, so we mirror the numeric values locally — exactly the pattern the
 * EngineX starter templates use. A "system" is any object implementing
 * `ISystem`: `{ name, phase, subPhase, priority, execute }`.
 */

import type { ISystem, World } from 'enginex';

export const Phase = {
  Input: 0,
  FixedSim: 1,
  Animation: 2,
  RenderSub: 3,
  Render: 4,
  Post: 5,
  UI: 6,
} as const;

export const Sub = { PreUpdate: 0, Update: 1, PostUpdate: 2 } as const;

/** Wrap a per-frame callback as an ISystem the engine scheduler can run. */
export function makeSystem(
  name: string,
  phase: number,
  priority: number,
  execute: (dt: number, world: World) => void,
  subPhase: number = Sub.Update,
): ISystem {
  return { name, phase, subPhase, priority, execute } as unknown as ISystem;
}
